import { apiGet, apiPost, apiPatch, apiDelete } from './apiRequest';

export const getSSRsForDeviceService = async (deviceId) => {
    const res = await apiGet(`/ssrs?deviceId=${deviceId}`);
    return res?.data;
}

export const getAllAdminHeatersService = async () => {
    const res = await apiGet(`/heaters/search`);
    return res?.data;
}

export const getAdminHeatersService = async (partNumber) => {
    const res = await apiGet(`/heaters/search?partNumber=${partNumber}`);
    return res?.data;
}

export const addAdminHeatersService = async (data) => {
    const res = await apiPost(`/heaters`, data);
    return res?.data;
}

export const addHeaterToSSRService = async (deviceId, data) => {
    const res = await apiPost(`/ssrs/${deviceId}/heaters`, data);
    return res?.data;
}

export const deleteHeaterFromSSRService = async (deviceId, data) => {
    const res = await apiDelete(`/ssrs/${deviceId}/heaters`, { data });
    return res?.data;
}

export const updateHeaterOfSSRService = async (deviceId, data) => {
    const res = await apiPatch(`/ssrs/${deviceId}`, data);
    return res?.data;
}
